<template lang="pug">
div(
    class="list-tile"
    :class="{ chosen: checked, 'pointer': !!item.descriptions?.length }"
    data-testid="radio-list-element"
)
    div(
        class="grid"
    )
        div(
            class="input-select-item"
            :class="{ active: checked, disabled }"
            data-testid="radio-list-check"
            @click="handleClick"
        )
        Position(
            x="start"
            y="center"
            @click="toggle"
        )
            div(class="list-tile-label-wrapper")
                Words(
                    class="list-tile-label"
                    title
                ) {{ item.label }}

        Position(
            v-if="item.descriptions?.length"
            x="end"
            y="center"
            class="arrow"
            :class="{ 'isToggled': toggled }"
            data-testid="radio-list-toggle"
            @click="toggle"
        )
            i.mi-chevron-down


    transition(
        v-if="item.descriptions?.length"
        name="list-toggle"
        @enter="onEnter"
        @after-enter="onLeave"
        @before-leave="onEnter"
        @after-leave="onLeave"
    )
        .list-tile-content(
            v-if="toggled"
            data-testid="radio-list-description"
        )
            ul
                li(
                    v-for="(description, index) in item.descriptions"
                    :key="index"
                )
                    strong {{ description.label }}
                    span {{ description.value }}
</template>

<script lang="ts" setup>
import Position from 'widget-components/components/Position'
import Words from 'widget-components/components/Words'
import { ref } from 'vue'
import type { ListTileItem } from './types'

const props = defineProps<{
    item: ListTileItem
    disabled?: boolean
}>()

const checked = defineModel<boolean>({ default: false })
const toggled = ref(false)

const toggle = () => {
    toggled.value = !toggled.value
}

const handleClick = () => {
    if (props.disabled) {
        return 
    }
    checked.value = !checked.value
}

const onEnter = (el: Element) => {
    (el as HTMLElement).style.height = el.scrollHeight + 'px'
}

const onLeave = (el: Element) => {
    (el as HTMLElement).style.height = ''
}
</script>

<style lang="sass" scoped>
@import './InputRadioListTile.sass'
</style>
